import { BoReference } from './bo-reference.js'
import { ModuleImport } from './module-import.js'
import { BusinessObject } from './business-object.js'
import { ScreenRoute } from './screen-route.js'
import type {
	ModuleIdType,
	ModuleBundleType,
	BusinessObjectIdType,
} from '../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { BoVisitor } from './bo-visitor.js'
import { createSetNotifyProxy } from '../util/create-set-notify-proxy.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

@jsonClass('Module')
export class Module extends BusinessObject {
	@jsonProperty(String) bundle: ModuleBundleType = ''
	@jsonProperty(String) name: string = ''
	@jsonProperty(Boolean) isAppModule: boolean = true
	@jsonProperty(Boolean) isArchived: true | undefined = undefined
	@jsonProperty(String) tenantId?: string
	@jsonArrayProperty(String) includeLanguages: string[] = ['English']
	@jsonProperty(String) defaultLanguage: string = 'English'
	@jsonArrayProperty(BoReference) includeStyles: BoReference[] = []

	@jsonProperty(BoReference) defaultScreen: BoReference = new BoReference()
	@jsonProperty(BoReference) defaultTheme: BoReference = new BoReference()
	@jsonProperty(BoReference) appIcon: BoReference = new BoReference()
	@jsonArrayProperty(ScreenRoute) exposedScreenRoutes: ScreenRoute[] = []
	@jsonArrayProperty(ModuleImport) moduleImports: ModuleImport[] = [
		new ModuleImport({ moduleId: 'System', boId: 'System', boType: 'Module' }),
		new ModuleImport({ moduleId: 'Common', boId: 'Common', boType: 'Module' }),
	]
	@jsonProperty(Boolean) isSystemModule: boolean = false
	@jsonMapProperty(String, String) systemImports: Map<string, string> =
		new Map()

	constructor(init?: Partial<Module>) {
		super()
		assignCommonProperties(this, init)
		// this.type = 'Module'
		// this.moduleId = ModulesRootId
		this.moduleId = this.boId
	}

	hasUi() {
		return this.exposedScreenRoutes.length > 0
	}

	visit(visitor: BoVisitor): void {
		this.moduleImports.forEach((mi, idx) =>
			visitor.visitBoReference(mi, ['moduleImports', idx]),
		)
		if (this.defaultScreen)
			visitor.visitBoReference(this.defaultScreen, ['defaultScreen'])
		this.includeStyles.forEach((style, idx) =>
			visitor.visitBoReference(style, ['includeStyles', idx]),
		)
		this.exposedScreenRoutes.forEach((route, idx) =>
			visitor.visitBoReference(route, ['exposedScreenRoutes', idx]),
		)
		this.includeLanguages.forEach((languageId, idx) =>
			visitor.visitBoReference(
				createSetNotifyProxy(
					new BoReference({
						moduleId: 'Common',
						boType: 'Language',
						boId: languageId,
					}),
					{
						boId: (newId: BusinessObjectIdType) =>
							(this.includeLanguages[idx] = newId),
					},
				),
				['includeLanguages', idx],
			),
		)
	}
}
